var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 7h14l-1.5 13a2 2 0 01-2 1.8h-7a2 2 0 01-2-1.8L5 7zm4 0V5a3 3 0 016 0v2"}));
}

Bag.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.8"};

module.exports = Bag;

Bag.default = Bag;
